// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Chip/MultipleValues.story.tsx with go/sail-next-tailor-docs-publisher

import * as React from 'react';
import {Chip} from '@sail/ui';
import {Container} from './common';

export const MultipleValues = () => (
  <Container>
    <Chip
      label="Status"
      value={['Refunded', 'Succeeded']}
      onDropdown={() => {
        // eslint-disable-next-line no-alert
        alert('Dropdown function triggered');
      }}
      onClose={() => {
        // eslint-disable-next-line no-alert
        alert('Close function triggered');
      }}
    />
  </Container>
);
